import { ReactNode } from "react";

import { ConflictsBadge, EhrDataBadge, MissingDataBadge, SyncedBadge } from "@/src/components/cards/common";
import { Card, CardHeader, CardContent } from "@/src/components/shadcn/ui/card";

interface EHRCardProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  className?: string;
  missingData?: boolean;
  showSyncBadge?: boolean;
  hasAnyConflicts?: boolean;
}

export default function EHRCard({
  icon,
  title,
  children,
  className,
  missingData = false,
  showSyncBadge = true,
  hasAnyConflicts = false,
}: EHRCardProps) {
  return (
    <Card className={`w-full ${className || ""}`}>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="h-6 w-6 mr-2">{icon}</div>
            <h3 className="text-md font-semibold">{title}</h3>
          </div>
          <div className="flex items-center gap-2">
            {showSyncBadge && (hasAnyConflicts ? <ConflictsBadge /> : <SyncedBadge />)}
            {missingData ? <MissingDataBadge /> : <EhrDataBadge />}
          </div>
        </div>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
